import { makeAutoObservable } from "mobx";
import {
    deleteQuantityUnitById,
    getQuantityUnitById,
    pagingQuantityUnit,
    createQuantityUnit,
    updateQuantityUnit,
    saveQuantitySyncStore
} from 'app/services/QuantityUnitService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { QuantityUnit } from "app/common/Model/QuantityUnit";
import { checkSearchObject } from "app/common/LocalFunction";
import { saveDrugSyncStore } from "app/services/DrugService";
import { importQuantityUnit } from "app/services/ImportExcelService";

export default class quantityUnitStore {
    listAllQuantityUnit = [];
    searchQuantityUnit = new SearchObject();
    pageQuantityUnit = null;
    selectedQuantityUnit = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    openSyncStore = false;
    openImportExcelQuantityUnnit = false;

    constructor() {
        makeAutoObservable(this);
    }

    handleOpenImportExcelQuantityUnit = () => {
        this.openImportExcelQuantityUnnit = true;
    }
    handleCloseImportExcelQuantityUnit = () => {
        this.openImportExcelQuantityUnnit = false;
    }

    saveImportExcelQuantityUnit = (file) => {
        importQuantityUnit(file).then(() => {
            toast.success("Nhập excel thành công")
            this.searchConcept = {
                ...this.searchConcept,
                pageIndex: 1
            }
            this.pagingQuantityUnit();
            this.openImportExcelQuantityUnnit = false;
        }).catch(() => {
            toast.error("Nhập excel thất bại")
        }).
            finally(() => {
                this.handleClosePopup();
            })
    }

    getAllQuantityUnit = async (unitType) => {
        if (this.listAllQuantityUnit?.length === 0 || this.recentlyUpdated) {
            const searchObjectForAll = {
                pageSize: 1000000,
                pageIndex: 1,
                unitType: unitType,
            };

            pagingQuantityUnit(searchObjectForAll)
                .then(({ data }) => {
                    this.listAllQuantityUnit = data?.content;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu đơn vị tính có lỗi")
                })
        }
    }


    pagingQuantityUnit = async () => {
        return await pagingQuantityUnit(this.searchQuantityUnit)
            .then(({ data }) => {
                this.pageQuantityUnit = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu đơn vị tính có lỗi")
            })
    }

    handleChangeFormSearch = (searchQuantityUnit) => {
        this.searchQuantityUnit = checkSearchObject(this.searchQuantityUnit, searchQuantityUnit);
        this.pagingQuantityUnit();
    }

    handleOpenFormCreateOrEdit = (quantityUnitId) => {
        if (Boolean(quantityUnitId)) {
            getQuantityUnitById(quantityUnitId).then(({ data }) => {
                this.selectedQuantityUnit = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedQuantityUnit = new QuantityUnit();
            this.openFormCreateOrEdit = true;
        }
    }

    createQuantityUnit = (quantityUnit,  setSubmitting ,handleAfterSubmit) => {
        createQuantityUnit(quantityUnit)
            .then((res) => {
                if(handleAfterSubmit) handleAfterSubmit(res?.data)
                this.selectedQuantityUnit = null;
                toast.success("Lưu đơn vị tính thành công!");
                this.handleClosePopup();
                this.pagingQuantityUnit();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu đơn vị tính có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    updateQuantityUnit = (quantityUnit, { setSubmitting }) => {
        updateQuantityUnit(quantityUnit)
            .then(() => {
                this.selectedQuantityUnit = null;
                toast.success("Lưu đơn vị tính thành công!");
                this.handleClosePopup();
                this.pagingQuantityUnit();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu đơn vị tính có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (quantityUnit) => {
        this.selectedQuantityUnit = { id: quantityUnit?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteQuantityUnitById(this.selectedQuantityUnit?.id)
            .then(() => {
                if (this.searchQuantityUnit?.pageIndex > 1 && this.pageQuantityUnit?.content?.length === 1) {
                    this.searchQuantityUnit.pageIndex -= 1;
                }
                toast.success("Xóa đơn vị tính thành công!");
                this.handleClosePopup();
                this.pagingQuantityUnit();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa đơn vị tính có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    handleOpenSyncStore = () => {

        this.openSyncStore = true
    }

    handleCloseSyncStore = () => {
        this.openSyncStore = false
    }

    handleSaveSyncStore = (data, { setSubmitting }) => {
        saveQuantitySyncStore(data).then(() => {
            this.openSyncStore = false;
            toast.success("Đồng bộ đơn vị tính thành công")
            this.pagingQuantityUnit()
        }).catch((err) => {
            toast.error("Đồng bộ đơn vị tính thất bại")
        }).finally(() => {
            setSubmitting(false)
        })
    }

    resetStore = () => {
        this.searchQuantityUnit = new SearchObject();
        this.pageQuantityUnit = null;
        this.selectedQuantityUnit = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
        this.openImportExcelQuantityUnnit = false;
    }
}
